import { defineAsyncComponent, markRaw } from 'vue'

const extendFiches = import.meta.glob('@/extend/fiches/*.vue')
const extendSections = import.meta.glob('@/extend/sections/*.vue')
const customSections = import.meta.glob('@/custom/sections/*.vue')

export function getFiche(name: string) {
    const path = `/src/extend/fiches/${name}.vue`
    return extendFiches[path] ?? null
}

export function resolveFicheComponent(abstractName: string) {
    const loader = getFiche(abstractName)
    return loader ? markRaw(defineAsyncComponent(loader as any)) : null
}

export function getSection(name: string) {
    const path = `/src/extend/sections/${name}.vue`
    if (!extendSections[path]) {
        const customPath = `/src/custom/sections/${name}.vue`
        return customSections[customPath] ?? null
    } else {
        return extendSections[path] ?? null
    }
}

export function resolveSectionComponent(abstractName: string) {
    const loader = getSection(abstractName)
    return loader ? markRaw(defineAsyncComponent(loader as any)) : null
}